import React from 'react';
import { BanknoteIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { PRICE, TOMOS_VALUE, BONOS_VALUE, TOTAL_VALUE, SAVINGS, DISCOUNT } from '../data/content';
import { CountdownTimer } from './CountdownTimer';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const includes = ['Tomo 1: 40 recetas con costo por pieza', 'Tomo 2: 6 menús completos para reuniones', 'Tomo 3: paso a paso para tus primeros pedidos', 'Los 5 bonos (4 en PDF y 1 en Excel)'];
const valueRows = [{
  label: '3 tomos principales',
  value: TOMOS_VALUE
}, {
  label: '5 bonos',
  value: BONOS_VALUE
}];
const assurances = [{
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}, {
  icon: BanknoteIcon,
  label: 'Tarjeta o pago local'
}];
type OfferProps = {
  showUrgency?: boolean;
};
export function Offer({
  showUrgency = true
}: OfferProps) {
  return <section id="oferta" className="bg-sand py-20 sm:py-28 space-y-[12px]" aria-labelledby="oferta-title" style={{
    paddingTop: "50px",
    paddingBottom: "50px"
  }} data-id="element-141" data-mp="pkh4r5ywamdk">
      <div className="mx-auto max-w-5xl px-6" data-id="element-142" data-mp="ul4wjtuy778u">
        {showUrgency ? <Reveal data-id="element-143" data-mp="zjpwds6afowr">
            <div className="rounded-3xl bg-cream px-6 py-10 sm:px-12" data-id="element-144" data-mp="zj6cw70zosgm">
              <CountdownTimer label="PROMO HASTA" note={`Hoy ${PRICE} en lugar de ${TOTAL_VALUE}.`} data-id="element-145" data-mp="13iynsqduvap5" />
            </div>
          </Reveal> : null}

        <Reveal className={showUrgency ? 'mt-16' : ''} data-id="element-146" data-mp="6rwg60q8b3fk">
          <div className="text-center" data-id="element-147" data-mp="btlv3rgko18x">
            <h2 id="oferta-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-148" data-mp="bqg4g7saorb3">
              Llévate Catering para Emprender completo
            </h2>
            <p className="mt-4 text-lg text-ink-soft" data-id="element-149" data-mp="kn8k8yq9y695">
              Los 3 tomos y los 5 bonos en un solo pago.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.06} data-id="element-150" data-mp="3o96023cyjgrc">
          <div className="mx-auto mt-12 max-w-3xl overflow-hidden rounded-3xl border border-cream-line bg-white shadow-lift" data-id="element-151" data-mp="3o84l3nstma4c">
            <p className="bg-mint-700 py-2.5 text-center text-sm font-semibold uppercase tracking-[0.16em] text-white" data-id="element-152" data-mp="qgntyn6ljgmv">
              Todo incluido · acceso inmediato
            </p>

            <div className="grid gap-10 p-8 sm:p-12 md:grid-cols-[minmax(0,1fr)_minmax(0,0.9fr)]" data-id="element-153" data-mp="157d2tiwl4jnk">
              <div data-id="element-154" data-mp="108ti1ltq9dws">
                <h3 className="font-display text-3xl text-ink" data-id="element-155" data-mp="cgmo0tbh5j0j">Pack completo</h3>
                <ul className="mt-6 space-y-3" data-id="element-156" data-mp="cipne3yioohx">
                  {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-157" data-mp="7jmj4lqd2mb0">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-mint-700" aria-hidden="true" data-id="element-158" data-mp="lim6lq250v5l" />
                      <span className="text-[15px] text-ink-soft" data-id="element-159" data-mp="hewpflnslful">{item}</span>
                    </li>)}
                </ul>

                <dl className="mt-8 space-y-2 border-t border-cream-line pt-6 text-sm" data-id="element-160" data-mp="1wuwtjfu79x24">
                  {valueRows.map(row => <div key={row.label} className="flex justify-between gap-4" data-id="element-161" data-mp="1sx7f9zczs67a">
                      <dt className="text-ink-muted" data-id="element-162" data-mp="20d2psuc1mdtn">{row.label}</dt>
                      <dd className="text-ink-soft" data-id="element-163" data-mp="25e0cnk7zzw1h">{row.value}</dd>
                    </div>)}
                  <div className="flex justify-between gap-4 font-semibold text-ink" data-id="element-164" data-mp="1qh9dnc28kmce">
                    <dt data-id="element-165" data-mp="1vf13m0jblydy">Valor total</dt>
                    <dd data-id="element-166" data-mp="1vg2rj5lfqfd3">{TOTAL_VALUE}</dd>
                  </div>
                </dl>
              </div>

              <div className="flex flex-col" data-id="element-167" data-mp="2j5n9bl5ur6ks">
                <p className="text-sm text-ink-muted line-through" data-id="element-168" data-mp="2o3yli2jmdt66">{TOTAL_VALUE}</p>
                <p className="mt-1 font-display text-6xl leading-none text-mint-700" style={{
                fontSize: "56px"
              }} data-id="element-169" data-mp="29fbwf946xn1r">
                  {PRICE}
                </p>
                <p className="mt-4 inline-flex w-fit flex-wrap items-center gap-1 rounded-full bg-terra-light px-3 py-1.5 text-sm font-semibold text-terra-dark" data-id="element-170" data-mp="2ec2ajqwfq8kj">
                  Ahorras {SAVINGS} · {DISCOUNT} de descuento
                </p>

                <div className="mt-8" data-id="element-171" data-mp="1j6o5ecsbh851">
                  <CtaButton className="w-full" data-id="element-172" data-mp="1j4bgffo55xih">Quiero empezar a vender</CtaButton>
                </div>

                <p className="mt-auto pt-6 text-xs leading-relaxed text-ink-muted" data-id="element-173" data-mp="1e9eawiq2m6ac">
                  El precio está expresado en pesos mexicanos (MXN). Si compras desde otro país, el cobro se convierte a tu moneda al tipo de cambio del momento.
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.04} data-id="element-174" data-mp="1wx9h9hjcshtf">
          <div className="mx-auto mt-10 max-w-3xl" data-id="element-175" data-mp="1wz43r0a9whzm">
            <p className="text-center text-sm font-medium text-ink" data-id="element-176" data-mp="1s72u7m4hp5da">
              Precio en pesos mexicanos
            </p>

            <ul className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-3" data-id="element-177" data-mp="1n8rjzaaa8suj">
              {assurances.map(item => <li key={item.label} className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-ink-muted" data-id="element-178" data-mp="2kof8esuquwj1">
                  <item.icon className="h-4 w-4 text-mint-700" aria-hidden="true" data-id="element-179" data-mp="2fv400naaa7p0" />
                  {item.label}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}